import _ from "lodash";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  RECIPE_MANAGEMENT_INITIALIZATION,
  RECIPE_MANAGEMENT_INGREDIENT_TOGGLE,
  RECIPE_MANAGEMENT_INGREDIENT_FILTER,
  RECIPE_MANAGEMENT_RECIPE_SELECT_TOGGLE,
  RECIPE_MANAGEMENT_DELETE,
  RECIPE_MANAGEMENT_UPDATE_RATING,
  RECIPE_MANAGEMENT_UPDATE_RANK,
  ON_CHANGE_MEALPLANMODAL,
  ON_SUBMIT_MEALPLANMODAL,
  ON_CHANGE_SHARE,
  ON_SHARE,
  CHECK_USER_RECIPES,
  SHARE_SUCCESS_STATUS,
  CLEAR_EDIT_REGIMEN,
} from "../actions/constant";
import i18n from "../i18n";
import { recipeFilter } from "../services/RecipeService";
import moment from "moment";
import { convertHHMMForDisplay } from "../lib/helper";

const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  recipesAll: [],
  recipes: [],
  shareSuccess: false,
  shareError: false,
  shareErrorMsg: "",
  selectedItems: [],
  mPlanModal: {
    mPlanDate: moment(),
  },
  recipeManagementForm: {
    sortBy: "rank",
    email: "",
  },
  counterState: 0,
};
function orderedListMaker(recipesFilter, sortBy) {
  if (sortBy == "null" || sortBy == "rank") {
    return _.orderBy(recipesFilter, ["rank"], ["asc"]);
  } else if (sortBy == "rating") {
    return _.orderBy(recipesFilter, ["rate", "rank"], ["desc", "asc"]);
  } else if (sortBy == "recipe") {
    return _.orderBy(
      recipesFilter,
      [
        (recipe) =>
          recipe.recipe
            ? recipe.recipe.toLowerCase()
            : recipe.name.toLowerCase(),
      ],
      ["asc", "asc"]
    );
  } else {
    return _.orderBy(recipesFilter, [sortBy, "rank"], ["desc", "asc"]);
  }
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case getStarted(RECIPE_MANAGEMENT_INITIALIZATION):
      localStorage.removeItem("logoutWithoutSaveRecipe");
      return { ...state, shareSuccess: false, isLoading: true };
    case getStarted(RECIPE_MANAGEMENT_DELETE):
    case getStarted(RECIPE_MANAGEMENT_UPDATE_RATING):
      return { ...state, isLoading: true };
    case getSucceeded(RECIPE_MANAGEMENT_INITIALIZATION):
      const recipesInitial = action.payload.map((recipe) => {
        recipe.isExpand = false;
        recipe.isSelected = false;
        recipe.rate = recipe.rate || 0;

        return recipe;
      });

      var defaultRecipeManagmentSorting = "rank"; //localStorage.getItem("defaultRecipeManagmentSorting");
      var recipeOrdered = orderedListMaker(
        { ...recipesInitial },
        defaultRecipeManagmentSorting
      );
      state.userLang = localStorage.getItem("i18nextLng");
      return {
        ...state,
        status: statusEnum.SUCCESS,
        recipesAll: recipesInitial,
        recipes: recipeOrdered,
        recipeManagementForm: {
          sortBy: defaultRecipeManagmentSorting,
        },
      };
    case getSucceeded(RECIPE_MANAGEMENT_DELETE):
      const ids = action.payload;
      let deletedRank = "";
      state.recipes.map((recipe) => {
        if (_.includes(ids, recipe._id)) {
          deletedRank = recipe.rank;
        }
      });
      const updatedArray1 = state.recipes.filter(
        (item) => item.rank !== deletedRank
      );
      const updatedArray2 = state.recipesAll.filter(
        (item) => item.rank !== deletedRank
      );
      const adjustRanks = (array) => {
        return array.map((item) => ({
          ...item,
          rank: item.rank > deletedRank ? item.rank - 1 : item.rank,
        }));
      };

      if (state.selectedItems.length >= 1) {
        state.selectedItems = state.selectedItems.filter(
          (item) => item.id !== action.payload
        );
      }
      return {
        ...state,
        recipes: adjustRanks(updatedArray1),
        recipesAll: adjustRanks(updatedArray2),
        status: statusEnum.SUCCESS,
      };
    case getSucceeded(RECIPE_MANAGEMENT_UPDATE_RATING):
      var rankrecipes = state.recipes;
      var recipeUpdateRatings = rankrecipes.map((recipe) => {
        if (recipe._id === action.payload.id) {
          recipe.rate = action.payload.rating;
        }
        return recipe;
      });
      if (state.recipeManagementForm.sortBy == "rating") {
        recipeUpdateRatings = _.orderBy(
          recipeUpdateRatings,
          ["rate"],
          ["desc"]
        );
      }
      return {
        ...state,
        recipes: recipeUpdateRatings,
        //counterState: state.counterState + 1,
        //recipeManagementForm: { ...state.recipeManagementForm, sortBy: "null" }
      };
    case RECIPE_MANAGEMENT_UPDATE_RANK:
      const rankUpdated = parseInt(action.payload.rank, 10);
      const rankBefore =
        action.payload.rankBefore === ""
          ? 0
          : parseInt(action.payload.rankBefore, 10);

      const updateRankByValue = (items, oldRank, newRank) => {
        const updatedItems = items.map((item) => ({ ...item }));

        const itemToUpdate = updatedItems.find((item) => item.rank === oldRank);
        if (!itemToUpdate) return updatedItems;
        if (oldRank === newRank) return updatedItems;

        const isMovingUp = oldRank < newRank;

        updatedItems.forEach((item) => {
          if (isMovingUp) {
            if (item.rank > oldRank && item.rank <= newRank) {
              item.rank--;
            }
          } else {
            if (item.rank >= newRank && item.rank < oldRank) {
              item.rank++;
            }
          }
        });

        itemToUpdate.rank = newRank;

        const rankSet = new Set();
        updatedItems.forEach((item) => {
          while (rankSet.has(item.rank)) {
            item.rank++;
          }
          rankSet.add(item.rank);
        });
        return updatedItems;
      };
      let recipeUpdateRanks = updateRankByValue(
        state.recipes,
        rankBefore,
        rankUpdated
      );
      recipeOrdered = [];
      if (state.recipeManagementForm.sortBy === "rank") {
        var defaultRecipeManagmentSorting = "rank";
        recipeOrdered = orderedListMaker(
          { ...recipeUpdateRanks },
          defaultRecipeManagmentSorting
        );
      } else {
        recipeOrdered = recipeUpdateRanks;
      }
      state.recipes = recipeOrdered;

      let recipesAllUpdatedRank = updateRankByValue(
        state.recipesAll,
        rankBefore,
        rankUpdated
      );
      state.recipesAll = recipesAllUpdatedRank;

      return {
        ...state,
      };
    case getFailed(RECIPE_MANAGEMENT_INITIALIZATION):
      state.recipeManagementForm = {
        ...state.recipeManagementForm,
        search: "",
      };
      return {
        ...state,
        recipesAll: [],
        recipes: [],
        actionResponse: action.payload,
        status: statusEnum.ERROR,
      };
    case getEnded(RECIPE_MANAGEMENT_INITIALIZATION):
      state.selectedItems = [];
      localStorage.removeItem("logoutWithoutSaveRegimen")
      localStorage.removeItem("logoutWithoutSaveRecipe")
      return { ...state, isLoading: false };
    case getEnded(RECIPE_MANAGEMENT_DELETE):
    case getEnded(RECIPE_MANAGEMENT_UPDATE_RATING):
      return { ...state, isLoading: false };
    case RECIPE_MANAGEMENT_INGREDIENT_TOGGLE:
      const recipeToggles = state.recipes.map((recipe) => {
        if (recipe._id === action.item._id) {
          recipe.isExpand = !recipe.isExpand;
          if (
            recipe.isExpand &&
            (typeof recipe.isDone == "undefined" || !recipe.isDone)
          ) {
            // recipe.ingredients = action.item.items
            //   ? action.item.items
            //   : action.item.ingredients;

            const src = action.item.items ? action.item.items : action.item.ingredients;
            recipe.ingredients = (Array.isArray(src) ? src : []).map((it) => {
              // Determine the currently displayed unit: unitid or the first of `unit[]`
              const unitList = Array.isArray(it.unit) ? it.unit.map(String) : [];
              const unitFirst = String(it.unitid || unitList[0] || "");
              const valueRaw = String(it.value || it.size || "");

              // Hours → HH;MM when decimal and ≥ 3h
              const disp = convertHHMMForDisplay(valueRaw, unitFirst);
              if (disp.unit === "445") {
                const newUnitList = ["445"].concat(unitList.filter((u) => String(u) !== "445"));
                return {
                  ...it,
                  // Ensure display shows HH;MM with HH:MM unit
                  value: disp.display,   // e.g., "3;01"
                  size: disp.display,    // (optional, harmless)
                  unitid: "445",         // (optional, helps if renderer uses unitid)
                  unit: newUnitList,     // put 445 first so label resolves to HH;MM
                };
              }
              return it;
            });




            recipe.name = action.item.fullname;
            recipe.size = action.item.size ? action.item.size : "";
            //recipe.symbol = action.item.symbol;
            recipe.comment = action.item.comment;
            recipe.isDone = 1;
          }
        }
        return recipe;
      });
      return { ...state, recipes: recipeToggles };
    case ON_CHANGE_MEALPLANMODAL:
      let mPlanModal = state.mPlanModal;
      mPlanModal[action.name] = action.value;
      state.mPlanModal = mPlanModal;
      return {
        ...state,
      };
    case getStarted(ON_SUBMIT_MEALPLANMODAL):
      return {
        ...state,
        isLoading: true,
      };
    case getSucceeded(ON_SUBMIT_MEALPLANMODAL):
      setTimeout(() => {
        const redirectTime = moment(state.mPlanModal.mPlanDate)
          .startOf("isoWeek")
          .unix();
        window.location.href = `/mealplansummary/${redirectTime}`;
      }, 1000);
      return { ...state, isLoading: false, saveSuccess: true };
    case getEnded(ON_SUBMIT_MEALPLANMODAL):
      return {
        ...state,
      };

    case RECIPE_MANAGEMENT_INGREDIENT_FILTER:
      const key = action.search ? action.search.toLowerCase() : "";
      let recipesFilter = state.recipes;
      recipesFilter = _.filter(state.recipesAll, recipeFilter(key));
      recipesFilter = orderedListMaker(recipesFilter, action.sortBy);
      return {
        ...state,
        recipes: recipesFilter,
        recipeManagementForm: {
          search: action.search,
          sortBy: action.sortBy,
          name: action.name,
        },
      };
    case RECIPE_MANAGEMENT_RECIPE_SELECT_TOGGLE:
      let selectedItems = state.selectedItems;
      let newSelect = [];

      state.recipes.map((recipe) => {
        if (recipe._id === action.id) {
          newSelect = [
            { recipe: recipe.recipe || recipe.fullname, id: action.id },
          ];
        }
        return recipe;
      });
      const array1Item = state.recipes.find((item) => item._id === action.id);
      const array2Item = state.recipesAll.find(
        (item) => item._id === action.id
      );
      const updatedRecipes = state.recipes.map((recipe) =>
        recipe._id !== action.id
          ? recipe
          : { ...recipe, isSelected: !array1Item.isSelected }
      );
      const updatedRecipesAll = state.recipesAll.map((recipe) =>
        recipe._id === action.id
          ? { ...recipe, isSelected: !array2Item.isSelected }
          : recipe
      );

      selectedItems = _.xorBy(selectedItems, newSelect, "id");
      return {
        ...state,
        recipes: updatedRecipes,
        recipesAll: updatedRecipesAll,
        selectedItems,
      };
    case ON_CHANGE_SHARE:
      state.recipeManagementForm.email = action.value;
      return {
        ...state,
      };
    case getStarted(ON_SHARE):
      return {
        ...state,
        isLoading: true,
        //shareSuccess: false,
        shareError: false,
        shareErrorMsg: "",
      };
    case getSucceeded(ON_SHARE):
      state.recipes.map((recipe) => {
        recipe.isSelected = false;
        return recipe;
      });
      state.recipesAll.map((recipe) => {
        recipe.isSelected = false;
        return recipe;
      });
      state.selectedItems = [];
      return { ...state, isLoading: false, shareSuccess: true };
    case getFailed(ON_SHARE):
      if (action.item === "email is invalid/missing") {
        state.shareErrorMsg =
          "The email you entered does not match any user. Please try again.";
      } else {
        state.shareErrorMsg = i18n.t(
          "recipe_management.SHARE_RECIPE_UNREGISTERED_EMAIL_TEXT"
        );
      }
      // state.recipes.map((recipe) => {
      //   recipe.isSelected = false;
      //   return recipe;
      // });
      return {
        ...state,
        isLoading: false,
        shareError: true,
        // recipes: recipeSelectToggles,
      };
    case getStarted(CHECK_USER_RECIPES):
      return { ...state, isLoading: true };

    case getSucceeded(CHECK_USER_RECIPES):
      state.checkedRecipes = action.check ? action.check : null;
      return { ...state, isLoading: false };

    case getFailed(CHECK_USER_RECIPES):
      state.checkedRecipes = {};
      return { ...state, isLoading: false };

    case SHARE_SUCCESS_STATUS:
      return { ...state, isLoading: false, shareSuccess: false };

    case CLEAR_EDIT_REGIMEN:
      return {
        ...state,
        saveSuccess: false,
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/recipeManagementReducer.js